module.exports = __webpack_public_path__ + "static/media/vse_DB702.44f59cab.jpg";